import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19f86e99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fault-analysis-wrap" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "可选服务", -1))
const _hoisted_4 = {
  class: "value analysis-tag-wrap",
  style: {"padding-top":"1px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tag-wrap base-type no-free-tag small-type orange-bg" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: ""
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "定责结果", -1))
const _hoisted_8 = { class: "value liabilityResultp-value" }
const _hoisted_9 = { class: "xag-flex y-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "view-btn xag-flex y-center" }, [
  /*#__PURE__*/_createTextVNode("查看 "),
  /*#__PURE__*/_createElementVNode("i", { class: "icon-right-green-svg" })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: ""
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "权益及定责", -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "qualitative-list" }
const _hoisted_16 = { class: "xag-flex y-center" }
const _hoisted_17 = { class: "view-btn" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "温馨提示", -1))
const _hoisted_20 = {
  key: 0,
  class: "value"
}
const _hoisted_21 = {
  key: 1,
  class: "pay-tip-wrap"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "付费定责工单待支付", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "已申请技术支持定责分析", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pay-btn icon-arrow-right-svg" }, null, -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 3,
  class: "value"
}
const _hoisted_27 = {
  key: 2,
  class: "tips"
}
const _hoisted_28 = {
  key: 3,
  class: "button-line"
}

import { useRouter } from 'vue-router'
import { xcareTypeClassNameMap } from '../service-tag'
import { withDefaults, computed } from 'vue'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair'
import { AUTH_WAREHOUSE } from '@/defination/malfunction-repair'
import {
  GetOrderAssociatedResponsibleResult,
  GetServiceOrderQualitativeResult,
  MalfunctionRepairServiceOrderDetail,
} from '@/types/malfunction-repair'
import BlockkWrapper from '../block-wrap.vue'
import ConfirmButton from './analysis-confirm-button.vue'
import ApplyButton from './analysis-apply-button.vue'
import IconArrowRightWrap from '@/components/icon/IconArrowRightWrap.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'detail-fault-analysis',
  props: {
    detail: { default: null },
    guid: { default: '' },
    qualitativeInfo: { default: null },
    serviceNo: { default: '' },
    serviceGuid: { default: '' },
    serviceOrderDetail: null,
    isPlant: { type: Boolean, default: false },
    payResponsibleWorkOrderInfo: { default: null }
  },
  emits: ['update'],
  setup(__props: any, { emit: emits }) {

const props = __props as { detail: null | GetOrderAssociatedResponsibleResult, guid: string, qualitativeInfo: null | GetServiceOrderQualitativeResult, serviceNo: string, serviceGuid: string, serviceOrderDetail: null | MalfunctionRepairServiceOrderDetail, isPlant: boolean, payResponsibleWorkOrderInfo: MalfunctionRepairServiceOrderDetail['pay_responsible_work_order'] | null };


const { addServiceOrderKeepAlive } = useMalfunctionRepairStore()
const $router = useRouter()



const responsible = computed(() => {
  return  props.detail?.responsible_work_order
})
const waitConfirm = computed(() => {
  return responsible.value?.status === 'WAIT_CONFIRM'
})
const isEnd = computed(() => {
  return responsible.value?.status === 'END'
})
const isSystemAnalysis = computed(() => {
  // 是否为系统分析
  return responsible.value?.type === 1
})
// 添加技术支持要非炸机的情况
const isSystemAnalysisAddCondition = computed(() => {
  // 是否为系统分析
  return isSystemAnalysis && isBoom.value
})
const isAuthWarehouse = computed(() => {
  return props.serviceOrderDetail?.repair_warehouse?.type === AUTH_WAREHOUSE
})
const isBoom = computed(() => {
  return props.serviceOrderDetail?.is_boom === 1
})
const qualitativeInfoList = computed(() => {
  if (!props.qualitativeInfo) {
    return []
  }
  return props.qualitativeInfo.display.filter(_ => _.type !== 'responsibility').map((item) => ({
    ...item,
    iconClass: item.status === 1 ? 'icon-rights-success-svg' : 'icon-rights-warn-svg',
    color: item.status === 1 ? 'rgba(0, 0, 0, 0.88)' : '#f7981c',
    show: !!item.show,
  }))
})

const liabilityResult = computed(() => {
  if (!props.qualitativeInfo) {
    return null
  }
  let item = props.qualitativeInfo.display.filter(_ => _.type === 'responsibility').map((item) => ({
    ...item,
    iconClass: item.status === 1 ? 'icon-rights-success-svg' : 'icon-rights-warn-svg',
    color: item.status === 1 ? 'rgba(0, 0, 0, 0.88)' : '#f7981c',
    show: !!item.show,
  }))
  return item[0] ? item[0] : null
})
const canAppeal = computed(() => {
  // 是否能申诉或申请技术支持
  return (
    (responsible.value?.appeal_num !== undefined && responsible.value?.appeal_num <= 1) ||
    (!isHardWare.value && isSystemAnalysis.value && waitConfirm.value)
  )
})
const showButton = computed(() => {
  // 待客户确认、非硬件、系统自动定责或技术支持但申诉不超过两次时
  return waitConfirm.value && isAuthWarehouse.value
})
const isTechnicalSupport = computed(() => {
  // 是否为技术支持类型
  return responsible.value?.type === 3
})
const isHardWare = computed(() => {
  return responsible.value?.analysis_responsibility_type === 'HARDWARE'
})
const hasAnalysis = computed(() => {
  return waitConfirm.value || isEnd.value
})
const flyInfo = computed(() => {
  return props.qualitativeInfo?.['72_fly']
})
const flyInfoTextStyle = computed(() => {
  const data = flyInfo.value
  return {
    color: data.text.indexOf('不通过') !== -1 ? '#F85359' : '#f7981c',
  }
})
const isShowTag = computed(() => {
  if (!props.qualitativeInfo) {
    return false
  }
  return (
    props.qualitativeInfo.service_type !== 'NO' && props.qualitativeInfo.service_type !== 'UNKNOWN'
  )
})
const tagClass = computed(() => {
  if (!props.qualitativeInfo) {
    return ''
  }
  return ['tag-wrap', 'base-type']
    .concat(xcareTypeClassNameMap[props.qualitativeInfo.service_type])
    .join(' ')
})
const analysisResult = computed(() => {
  // 分析结果, 定责和待客户确认时显示 硬件和非硬件， 其他情况显示状态
  if (hasAnalysis.value) {
    return responsible.value?.analysis_responsibility_type_text
  }
  return responsible.value?.status_text || ''
})
const tips = computed(() => {
  // 根据工单类型显示提示
  const type = responsible.value?.type
  if (type === 1) {
    return '以上为系统自动分析结果'
  } else if (type === 3) {
    if (hasAnalysis.value) {
      return '以上为极飞技术支持定责结果'
    } else {
      return '已申请技术支持定责分析'
    }
  }
  return '-'
})
const message = computed(() => {
  // props.qualitativeInfo.is_quality === 2
  if (isHardWare.value) {
    // 责任为硬件的时候，不需要客户确认结果
    if (isSystemAnalysis.value && props?.qualitativeInfo?.is_quality !== 2) {
      // 如果
      return '系统检测到设备硬件异常，请转单并前往直营服务站/服务车进行维修。'
    }
  } else {
    // 非硬件的时候，如果是系统单可以申请技术支持
    // 如果是技术支持工单，根据申诉次数提示
    if (isSystemAnalysis.value) {
      // 添加非炸机情况下客户不能申请技术支持
      if (isBoom.value) {
        return '非炸机故障请联系提单网点申请技术支持人工定责！'
      }
      return '如对定责结果有异议，可以申请技术支持人工定责。'
    }
    if (isTechnicalSupport.value) {
      // 已申请技术支持
      if (hasAnalysis.value) {
        // 已经有分析结果的按状态显示，没有分析结果的不显示文案
        if (isEnd.value) {
          return '已确认定责，请联系网点进行维修。'
        }
        if (waitConfirm.value && canAppeal.value) {
          return '如对定责结果有异议，可以进行申诉'
        }
      }
    }
  }
  return ''
})



function update() {
  emits('update')
}
function toOvertimeAppeal() {
  addServiceOrderKeepAlive()
  setTimeout(() => {
    $router.push({
      name: 'malfunction-repair-repair-order-overtime-appeal',
      query: {
        first: flyInfo.value.can_appeal && !flyInfo.value.text ? '1' : '0',
        guid: props.guid,
        repair_sn: props.serviceNo,
        serviceGuid: props.serviceGuid,
        from: 'service',
      },
    })
  }, 50)
}
function toDutyResult() {
  addServiceOrderKeepAlive()
  setTimeout(() => {
    $router.push({
      name: 'malfunction-repair-repair-order-duty-result',
      query: {
        guid: props.serviceGuid,
        from: 'service-order',
        isPlant:String(props.isPlant),
        workGuid: props.payResponsibleWorkOrderInfo?.guid,
      },
    })
  }, 50)
}


function gotoPay () {
  $router.push({
    name: 'malfunction-repair-service-fee-invoice',
    query: {
      guid: props.payResponsibleWorkOrderInfo.guid,
      sn:props.serviceOrderDetail.serial_number,
      serviceGuid:props.serviceGuid,
    },

  })
}

function viewPayOrder() {
  $router.push({
      name: 'malfunction-repair-duty-result-appeal',
      query: {
        guid: props.guid,
        isPlant: String(props.isPlant),
        from:'payDuty',
        workGuid: props.payResponsibleWorkOrderInfo?.guid,
        isDetail: 'true'
      },
    })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockkWrapper, { title: "维修服务情况" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_unref(isShowTag))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(_unref(tagClass))
                }, null, 2))
              : _createCommentVNode("", true),
            _hoisted_5
          ])
        ]),
        (_unref(liabilityResult) && _unref(liabilityResult).show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["i-tag", _unref(liabilityResult).iconClass])
                  }, null, 2),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ color: _unref(liabilityResult).color })
                  }, _toDisplayString(_unref(liabilityResult).title), 5)
                ]),
                _createElementVNode("div", {
                  class: "operate",
                  onClick: toDutyResult
                }, _hoisted_11)
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(qualitativeInfoList).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("ul", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qualitativeInfoList), (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.type
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["i-tag", item.iconClass])
                        }, null, 2),
                        _createElementVNode("div", {
                          style: _normalizeStyle({ color: item.color })
                        }, _toDisplayString(item.title), 5)
                      ]),
                      (item.type === 'fly')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "operate",
                            onClick: toOvertimeAppeal
                          }, [
                            (_unref(flyInfo)?.text)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  style: _normalizeStyle(_unref(flyInfoTextStyle))
                                }, _toDisplayString(_unref(flyInfo).text) + "，", 5))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(flyInfo)?.can_appeal && !_unref(flyInfo).text ? '点击申诉' : '点击查看'), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          (!__props.payResponsibleWorkOrderInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(tips)), 1))
            : (__props.payResponsibleWorkOrderInfo.status === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", {
                    class: "pay-btn",
                    onClick: gotoPay
                  }, "前往支付")
                ]))
              : (__props.payResponsibleWorkOrderInfo.status === 2)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "pay-tip-wrap pay-tip-sucess-wrap",
                    onClick: viewPayOrder
                  }, _hoisted_25))
                : (_openBlock(), _createElementBlock("div", _hoisted_26, "-"))
        ]),
        (_unref(message))
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(message)), 1))
          : _createCommentVNode("", true),
        (_unref(showButton))
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createVNode(ConfirmButton, {
                guid: props.guid,
                onUpdate: update
              }, null, 8, ["guid"]),
              (_unref(isSystemAnalysisAddCondition) || _unref(isTechnicalSupport))
                ? (_openBlock(), _createBlock(ApplyButton, {
                    key: 0,
                    showMarginLeft: "",
                    isSystemAnalysis: _unref(isSystemAnalysis),
                    isTechnicalSupport: _unref(isTechnicalSupport),
                    guid: props.guid,
                    onUpdate: update,
                    canAppeal: _unref(canAppeal),
                    isPlant: __props.isPlant
                  }, null, 8, ["isSystemAnalysis", "isTechnicalSupport", "guid", "canAppeal", "isPlant"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})